import { environment } from '../environments/environment';

export class Apis {
  static me = `${environment.base_url}/api/getProfile`;
  static Login = `${environment.base_url}/api/login/email`;

  static refreshToken = `${environment.base_url}/api/refreshToken`;
  static accessControl = `${environment.base_url}/api/accessControl`;
  static byCategory = `${environment.base_url}/api/accessControl/byCategory`;
  static sendMail = `${environment.base_url}/api/trustedDevice/sendVerificationMailAgain`;

  static getLinksCreatedByMe = `${environment.base_url}/api/link/getLinksCreatedByMe`;
  static getLinksById = `${environment.base_url}/api/link/getLinkById`;
  static createLinks = `${environment.base_url}/api/link/createLink`;
  static updateShortLinks = `${environment.base_url}/api/link/updateShortLink`;
  static deactivateShortLinks = `${environment.base_url}/api/link/deActivateShortLink`;

  static getApiKeys = `${environment.base_url}/api/getApiKeys`;
  static deactivateApiKeys = `${environment.base_url}/api/deActivateApiKey`;
  static createApiKeys = `${environment.base_url}/api/createApiKey`;

  static dateRangeType = `${environment.base_url}/api/enums/dateRangeType`;

  static getUsers = `${environment.base_url}/api/getUsers`;
  static changeStatus = `${environment.base_url}/api/users/changeStatus`;
  static getCountOfLInkCreatedByUser = `${environment.base_url}/api/link/getCountOfLInkCreatedByUser`;
  static createUser = `${environment.base_url}/api/users/createUser`;
}
